<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
import {useRootStore} from '@/store/index.js'

const store = useRootStore()

store.initBrowserSizeLevel()
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>